<template>
  <div class="upper-limb-orthosis-base">
    <v-card
      flat
      tile
    >
      <v-card-actions class="justify-space-between">
        <v-btn
          text
          @click="prev"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-item-group
          v-model="onboarding"
          class="text-center"
          mandatory
        >
          <hr>
          <v-item
            v-for="n in steps"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              :input-value="active"
              icon
              @click="toggle"
            >
              {{ n }}
            </v-btn>
          </v-item>
        </v-item-group>
        <v-btn
          text
          @click="next"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
      <v-window
        v-model="onboarding"
        touchless
      >
        <v-container>
          <v-form ref="form">
            <!-- Step One -->
            <v-window-item>
              <StepOne
                :form="upperLimb"
                @schematic-with-elbow="schematicWithElbow"
                @schematic-without-elbow="schematicWithoutElbow"
              />
            </v-window-item>

            <!-- Step Two -->
            <v-window-item>
              <StepTwo :form="upperLimb" />
            </v-window-item>

            <!-- Step Three -->
            <v-window-item v-if="showSchematicWithoutElbow">
              <StepThree :form="upperLimb" />
            </v-window-item>

            <!-- Step Four -->
            <v-window-item v-if="showSchematicWithElbow">
              <StepFour :form="upperLimb" />
            </v-window-item>
          </v-form>
        </v-container>
      </v-window>
      <div class="save-container">
        <v-btn
          class="cancel"
          @click="dialog = true"
        >
          <v-icon>mdi-close</v-icon>Annuler
        </v-btn>
        <v-btn
          class="save"
          @click="onSubmit"
        >
          <v-icon>mdi-content-save</v-icon>Enregistrer
        </v-btn>
      </div>
    </v-card>

    <!-- Confirmation dialog -->
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Annulation
        </v-card-title>
        <v-card-text>Toutes modifications seront perdues !</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn
            color="red"
            dark
            text
            @click="$router.go(-1)"
          >
            Oui
          </v-btn>
          <v-btn
            text
            color="black"
            @click="dialog = false"
          >
            Non
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import handleProducts from "@/mixins/handleProducts.js";

import StepOne from "./components/StepOne";
import StepTwo from "./components/StepTwo";
import StepThree from "./components/StepThree";
import StepFour from "./components/StepFour";

export default {
  name: "UpperLimbOrthosisBase",
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour
  },
  mixins: [handleProducts],
  props: {
    projectUuid: {
      type: String,
      default: ""
    }
  },
  provide() {
    return { parentValidator: this.$validator };
  },
  data() {
    return {
      // How many steps for this product
      steps: 3,
      onboarding: 0,
      dialog: false,

      // Show Schematic with elbow
      showSchematicWithElbow: false,

      // Show Schematic without elbow
      showSchematicWithoutElbow: false,

      upperLimb: JSON.parse(
        JSON.stringify(this.$store.state.upperLimb.upperLimb)
      )
    };
  },
  beforeDestroy() {
    this.$store.dispatch("upperLimb/resetProduct");
  },
  methods: {
    // Submit product
    async onSubmit() {
      // Check if form is valid
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        if (this.errors.items.length > 0) {
          this.errors.items.map(e => {
            const notif = {
              message: e.msg,
              type: "error"
            };
            this.$store.dispatch("notifications/add", notif);
          });
          return;
        }
      }

      // Form is valid ! Save product
      this.saveProduct(this.upperLimb, this.projectUuid, "UPPER_LIMB_ORTHOSIS");
    },

    // Next step
    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    // Previous step
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    schematicWithElbow() {
      this.showSchematicWithoutElbow = false;
      this.showSchematicWithElbow = true;
      this.onboarding = 2;
    },

    schematicWithoutElbow() {
      this.showSchematicWithElbow = false;
      this.showSchematicWithoutElbow = true;
      this.onboarding = 2;
    }
  }
};
</script>

<style lang="scss"></style>
